import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { GFNButton } from '../ui/GFNButton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from 'react-router-dom';
import './FProfile.css';
import { fetchFunddata, fetchcoundata, fetchDocdata, UploadImageData, viewdata, EditData, RegisterData } from '../reduxactions/fundmanagersactions/FProfileActions';
import { fundmanagerapi } from '../ApiNames';
import { LoginService } from '../services/LoginService';

var imageuser = require('../assets/images/images.png');

export const FProfile = () => {
    //To get session values
    const uid = window.sessionStorage.getItem('uid');
    const usertype = window.sessionStorage.getItem('usertype');

    const dispatch = useDispatch()

    //To get profile data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchFunddata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const data = useSelector((state: RootState) => state.profiledata.fdata)

    //To get countrydata
    const fetchcountrydata = async () => {
        try {
            await dispatch(fetchcoundata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //Calling data once
    useEffectOnce(() => {
        fetchcountrydata();
        fetchDataAsync();

    }, [dispatch]);
    //To get Attacments data
    const fetchattachDataAsync = async () => {
        try {
            await dispatch(fetchDocdata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    //Calling data once
    useEffectOnce(() => {
        fetchcountrydata();
        fetchDataAsync();
        fetchattachDataAsync();
    }, [dispatch]);
    //Image Formats

    const docdata = useSelector((state: RootState) => state.profiledata.docdata)
    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            await dispatch(UploadImageData(file, uid) as any);
        } else {
        }
        toast1.current.show({ severity: 'success', summary: 'Success', detail: imgdata, life: 3000 })

        fetchDataAsync()
        setTimeout(() => {
            window.location.reload();
        }, 3000);

    };

    const imgdata = useSelector((state: RootState) => state.profiledata.imgdata)
    let imgmessage = '';


    {
        imgdata !== '' && (
            imgmessage = "Profile photo updated successfully"
        )
    }
    // const toast = useRef(imgmessage);
    const toast1 = useRef(imgdata);

    //Gender selecction
    const genderoptions = [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' }
    ]

    //Gender selecction
    const applicationstatusoptions = [
        { label: 'Yes', value: 'ACTIVE' },
        { label: 'No', value: 'INACTIVE' }
    ]
    //Gender selecction
    const transfersoptions = [
        { label: 'goods', value: 'goods' },
        { label: 'money', value: 'money' }
    ]

    interface Transfercountry {
        Id: string; // Change the type accordingly
        transfercountry: string; // Change the type accordingly
    }
    const countrydata = useSelector((state: RootState) => state.profiledata.countrydata)
    console.log("Countrydata:", countrydata)
    const [globalFilter, setGlobalFilter] = useState('');
    //To update Profile
    const [company, setcompany] = useState('');
    const [firstname, setfirstName] = useState('');
    const [lastname, setlastName] = useState('');
    const [email, setEmail] = useState('');
    const [licenceexpdate, setLicenceexpdate] = useState('');
    const [gender, setGender] = useState('');
    const [application_flag, setApplicationFlag] = useState('');
    const [phone, setPhone] = useState<number | any>('');
    const [address, setAddress] = useState('');
    const [country, setCountry] = useState('');
    const [transfercountry, setTransfercountry] = useState('');
    const [website, setWebsite] = useState('');
    const [transferlimit, setTransferlimit] = useState('');
    const [paypal, setPaypl] = useState('');
    const [resume, setResume] = useState('');
    const [transfertype, settransfertype] = useState('');
    const [licenceno, setLicenceno] = useState('');
    useEffect(() => {
        if (data.length > 0) {
            setcompany(data[0].company);
            setfirstName(data[0].firstname);
            setlastName(data[0].lastname);
            setEmail(data[0].email);
            setLicenceno(data[0].licenceno);
            setLicenceexpdate(data[0].licenceexpdate);
            setGender(data[0].gender);
            setApplicationFlag(data[0].application_flag);
            setPhone(data[0].phone);
            setAddress(data[0].address);
            setCountry(data[0].country);
            setTransfercountry(data[0].transfercountry);
            settransfertype(data[0].transfertype);
            setPaypl(data[0].paypal);
            setWebsite(data[0].website);
            setTransferlimit(data[0].transferlimit);
            setResume(data[0].resume);


        }


    }, [data]);

    const editdata = useSelector((state: RootState) => state.profiledata.updatedata)

    const msgs = useRef(null);
    useEffect(() => {
        if (editdata && editdata.length > 0) {
            toast1.current.show({ severity: 'info', summary: 'info', detail: editdata, life: 3000 })

        }

    }, [editdata]);

    const fmprofile = async () => {
        try {
            await dispatch(EditData(company, firstname, lastname, email, licenceno, licenceexpdate, gender, application_flag, phone,
                address, country, transfercountry, transfertype, paypal, website, transferlimit, resume, uid) as any);

        } catch (error) {
            console.log("error while updating profile", error)
        }

        fetchDataAsync()
        setTimeout(() => {
            window.location.reload();
        }, 3000);

    }




    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }


    const viewupload = (rowData: any) => {
        console.log("RowData:", rowData)
        assignData.current = { did: rowData.DocID }

        setfield(true);
        fetchDataAsyncdialog()
    };
    const assignData = useRef({ did: '' })

    const fetchDataAsyncdialog = async () => {
        try {
            const { did } = assignData.current;
            console.log("DocID", did)
            await dispatch(viewdata(did) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }
    const navigate = useNavigate();
    const dataview = useSelector((state: RootState) => state.profiledata.dataview)

    const Donates = () => {
        const url = `/fundslist`;

        // Use navigate to navigate to the URL
        navigate(url);
    };

    const regdatas = useSelector((state: RootState) => state.profiledata.regdata)
    const toast3 = useRef(regdatas);

    const msgs1 = useRef(null);
    useEffect(() => {
        if (regdatas && regdatas.length > 0) {

        }

    }, [regdatas]);

    const Applyprofile = async (response: any) => {
        try {
            // await dispatch(RegisterData(company, firstname, lastname, email, licenceno, licenceexpdate, gender, application_flag, phone,
            //     address, country, transfercountry, transfertype, paypal, website, transferlimit, resume, uid) as any);;
            const payload = {
                company: company, firstName: firstname, lastName: lastname, email: email,
                licenceno: licenceno, licenceexpdate: licenceexpdate, gender: gender, application_flag: application_flag, phone: phone, address: address, country: country, transfercountry: transfercountry,
                transfertype: transfertype, paypal: paypal, website: website, transferlimit: transferlimit, resume: resume, uid: uid
            };
            const apiname = fundmanagerapi.editprofile;
            const response = await LoginService.getData(apiname, payload)
            if (toast3.current) {
                toast3.current.show({ severity: 'success', detail: response, life: 3000 })
            }
        }
        catch (error) {
            console.log("error while updating profile", error)
        }
        // setTimeout(() => {
        //     window.location.reload();
        // }, 3000);
    }
    const handlePhoneChange = (e: any) => {
        const inputPhone = e.target.value;
        // Using regex to keep only digits and limiting to 10 digits
        const formattedPhone = inputPhone.replace(/\D/g, '').slice(0, 10);
        setPhone(formattedPhone);
    };

    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/fmprofile.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Profile</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel>
                            {data.map((response: any) => (
                                <div className="grid" key={response.idcard_no}>
                                    {/* LEFT PROFILE CARD */}
                                    <div className="col-12 md:col-3">
                                        <div className="card flex flex-column align-items-center p-4 border-round shadow-1 bg-white">
                                            <div className="relative mb-3">
                                                <img
                                                    src={response.photo ? response.photo : imageuser}
                                                    alt="Profile"
                                                    className="shadow-2 border-circle border-3 border-white"
                                                    style={{
                                                        width: '120px',
                                                        height: '120px',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            </div>

                                            <h3 className="m-0 text-900 font-semibold text-xl text-center">
                                                {response.firstname}
                                            </h3>

                                            <p className="text-500 font-medium text-sm mb-4 mt-1">
                                                Fund Manager Profile
                                            </p>

                                            <div className="w-full">
                                                <FileUpload
                                                    mode="basic"
                                                    name="fileToUpload"
                                                    customUpload
                                                    accept="image/*"
                                                    maxFileSize={1000000}
                                                    uploadHandler={UploadManagerImage}
                                                    chooseLabel="Change Photo"
                                                    className="p-button-sm p-button-outlined w-full"
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    {/* RIGHT SIDE */}

                                    <div className="col-12 md:col-9">

                                        <Panel header="Personal Details" toggleable className="mb-4 shadow-1">

                                            <div className="grid">
                                                <div className="col-12 md:col-5">
                                                    <h2 className="text-left text-900 font-bold">
                                                        PROFILE ({response.status})
                                                    </h2>
                                                </div>
                                            </div>

                                            <Card className="surface-card border-round shadow-2">

                                                <div className="grid p-fluid">

                                                    {/* Left Column */}
                                                    <div className="col-12 md:col-6 px-4">

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Asset Management Firm
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={company}
                                                                    data-testid='firm-input'
                                                                    placeholder='Enter Management Firm'
                                                                    onChange={(e) => setcompany(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                First Name
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={firstname}
                                                                    data-testid='firstname-input'
                                                                    placeholder='Enter Firstname'
                                                                    onChange={(e) => setfirstName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Last Name
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={lastname}
                                                                    data-testid='lastname-input'
                                                                    placeholder='Enter Lastname'
                                                                    onChange={(e) => setlastName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                E-mail
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={email}
                                                                    data-testid='email-input'
                                                                    disabled
                                                                    className="bg-gray-100"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                License Number
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={licenceno}
                                                                    data-testid='licence-input'
                                                                    placeholder='Enter Lice.No'
                                                                    onChange={(e) => setLicenceno(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                License Expiry Date
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    type="date"
                                                                    value={licenceexpdate}
                                                                    data-testid='licence-date'
                                                                    placeholder='dd-mm-yyyy'
                                                                    onChange={(e) => setLicenceexpdate(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Gender
                                                            </label>
                                                            <div className="col-12">
                                                                <Dropdown
                                                                    value={gender}
                                                                    data-testid='gender-slect'
                                                                    onChange={(e) => setGender(e.value)}
                                                                    options={genderoptions}
                                                                    style={{ textAlign: 'left' }}
                                                                    optionLabel="label"
                                                                    optionValue="value"
                                                                    placeholder="Select Gender"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Accepting Applications
                                                            </label>
                                                            <div className="col-12">
                                                                <Dropdown
                                                                    value={application_flag}
                                                                    data-testid='application-select'
                                                                    style={{ textAlign: 'left' }}
                                                                    onChange={(e) => setApplicationFlag(e.value)}
                                                                    options={applicationstatusoptions}
                                                                    optionLabel="label"
                                                                    optionValue="value"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Resume
                                                            </label>
                                                            <div className="col-12">
                                                                <InputTextarea
                                                                    value={resume}
                                                                    data-testid='resumne-textarea'
                                                                    placeholder='Enter Resume'
                                                                    onChange={(e) => setResume(e.target.value)}
                                                                    rows={6}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>

                                                    {/* Right Column */}

                                                    <div className="col-12 md:col-6 px-4">

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Address
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={address}
                                                                    data-testid='address-input'
                                                                    placeholder='Enter Address'
                                                                    onChange={(e) => setAddress(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Country
                                                            </label>
                                                            <div className="col-12">
                                                                <Dropdown
                                                                    value={country}
                                                                    data-testid='country-select'
                                                                    onChange={(e) => setCountry(e.value)}
                                                                    options={countrydata}
                                                                    optionLabel="CountryName"
                                                                    placeholder="Select Country"
                                                                    style={{ textAlign: 'left' }}
                                                                    optionValue="CountryID"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Transfer Country
                                                            </label>
                                                            <div className="col-12">
                                                                <Dropdown
                                                                    value={transfercountry}
                                                                    data-testid='trasfercountry-select'
                                                                    onChange={(e) => setTransfercountry(e.value)}
                                                                    options={countrydata}
                                                                    optionLabel="CountryName"
                                                                    placeholder="Select Country"
                                                                    style={{ textAlign: 'left' }}
                                                                    optionValue="CountryID"
                                                                    multiple
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Transfer Type
                                                            </label>
                                                            <div className="col-12">
                                                                <Dropdown
                                                                    value={transfertype}
                                                                    data-testid='type-select'
                                                                    onChange={(e) => settransfertype(e.value)}
                                                                    options={transfersoptions}
                                                                    placeholder="Select Type"
                                                                    style={{ textAlign: 'left' }}
                                                                    optionLabel="label"
                                                                    optionValue="value"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Paypal Account
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={paypal}
                                                                    data-testid='paypal-input'
                                                                    placeholder='Enter Paypal Account'
                                                                    onChange={(e) => setPaypl(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Website Url
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={website}
                                                                    data-testid='website-input'
                                                                    placeholder='Enter Website'
                                                                    onChange={(e) => setWebsite(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Transfer Limit
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={transferlimit}
                                                                    data-testid='limit-input'
                                                                    placeholder='Enter Limit'
                                                                    onChange={(e) => setTransferlimit(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 md:col-12 text-center text-800 font-semibold mb-2">
                                                                Phone Number
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={phone}
                                                                    data-testid='phone-input'
                                                                    placeholder='Enter PhoneNumber'
                                                                    onChange={handlePhoneChange}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>

                                                {/* BUTTONS */}

                                                <div className="flex justify-content-end gap-2 mt-4">

                                                    {response.status === 'APPLIED' || response.status === 'APPROVED' ? (
                                                        <GFNButton buttonType="primary" label="Save" testId='save-btn' onClick={fmprofile} />
                                                    ) : null}

                                                    {(response.status === 'REGISTERED' || response.status === 'REJECTED') && (
                                                        <GFNButton buttonType="success" label="Apply" testId='apply-btn' onClick={() => Applyprofile(response)} />
                                                    )}

                                                </div>

                                            </Card>

                                            <br />

                                            {/* ATTACHMENTS */}

                                            <Panel header="Attachments" toggleable>

                                                <div className="card flex mb-3">
                                                    <span className="p-input-icon-left">
                                                        <i className="pi pi-search" />
                                                        <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                    </span>
                                                </div>

                                                <DataTable value={docdata} paginator rows={5} stripedRows>

                                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No" />
                                                    <Column field="doc_name" header="Title" />
                                                    <Column field="expiry_date" header="Expiry Date" />

                                                    <Column header="Operations" body={(rowData, { rowIndex }) => (
                                                        <GFNButton icon="pi pi-eye" buttonType="primary" testId={`view-btn-${rowIndex}`} rounded outlined onClick={() => viewupload(rowData)} />
                                                    )} />

                                                </DataTable>

                                            </Panel>

                                        </Panel>

                                    </div>

                                </div>
                            ))}
                        </Panel>

                        <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>
                            <div className="modal-header">
                                <GFNButton icon="pi pi-times" buttonType="secondary" />
                            </div>
                            <div className="modal-body">
                                {dataview.map((response: any, index: number) =>
                                    <div key={index}>
                                        {response.filetype === 'image' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                                        {response.filetype !== 'image' &&
                                            <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                                        }
                                    </div>
                                )}
                            </div>
                        </Dialog>
                        <Toast  >
                            <Message severity="success" content={imgmessage} />
                        </Toast>
                        <Toast ref={toast1} >
                            <Message severity="success" content={imgdata}></Message>
                        </Toast>

                        <Toast ref={toast3} >
                            <Message severity="success" content={regdatas}></Message>
                        </Toast>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default FProfile
